(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["honey-peak-timeline"] && !Shopify.designMode) return;
  try {
    
(function(){
  var X0=46, X1=452, YT=20, YB=240;
  function wx(w){ return X0 + (w-1)*((X1-X0)/11); }
  function vy(v){ return YB - (v/10)*(YB-YT); }

  function buildChart(svg, curve, reveal){
    var s="";
    [2,4,6,8,10].forEach(function(v){
      var y=vy(v);
      s+='<line class="hp-grid" x1="'+X0+'" y1="'+y+'" x2="'+X1+'" y2="'+y+'"/>';
      s+='<text class="hp-tick" x="'+(X0-10)+'" y="'+(y+5)+'" text-anchor="end">'+v+'</text>';
    });
    s+='<line class="hp-axis" x1="'+X0+'" y1="'+YT+'" x2="'+X0+'" y2="'+YB+'"/>';
    s+='<line class="hp-axis" x1="'+X0+'" y1="'+YB+'" x2="'+X1+'" y2="'+YB+'"/>';
    for(var w=1; w<=12; w++){
      s+='<text class="hp-tick" x="'+wx(w)+'" y="'+(YB+22)+'" text-anchor="middle">'+w+'</text>';
    }
    s+='<text class="hp-axis-title" x="'+(X1-2)+'" y="'+(YB+48)+'" text-anchor="end">'+svg.dataset.axisx+'</text>';
    var my=(YT+YB)/2;
    s+='<text class="hp-axis-title" x="14" y="'+my+'" text-anchor="middle" transform="rotate(-90 14 '+my+')">'+svg.dataset.axisy+'</text>';
    var pts=curve.slice(0, reveal);
    s+='<polyline class="hp-data-line" points="'+pts.map(function(p){return wx(p[0])+','+vy(p[1]);}).join(' ')+'"/>';
    pts.forEach(function(p){ s+='<circle class="hp-dot" cx="'+wx(p[0])+'" cy="'+vy(p[1])+'" r="5"/>'; });
    svg.innerHTML=s;
  }

  function esc(str){ var d=document.createElement('div'); d.textContent=str; return d.innerHTML; }

  function initSection(root){
    if(!root || root.dataset.hpInit) return;
    var cfgEl=root.querySelector('[data-hp-config]');
    if(!cfgEl) return;
    var cfg;
    try{ cfg=JSON.parse(cfgEl.textContent); }catch(e){ return; }
    if(!cfg.tabs || !cfg.tabs.length) return;

    var svg=root.querySelector('.hp-chart');
    svg.dataset.axisx=esc(cfg.axisX||'');
    svg.dataset.axisy=esc(cfg.axisY||'');

    var tabs=root.querySelectorAll('.hp-tab');
    var bgEl=root.querySelector('[data-hp-bg]');
    /* when a static section background is set, JS never touches the background */
    var staticBg = !!(cfg.staticBg) || !!(bgEl && bgEl.getAttribute('data-hp-static')==='1');

    var prefetched={};
    function prefetch(i){
      if(staticBg) return;
      var t=cfg.tabs[i];
      if(!t || !t.bg || prefetched[i]) return;
      prefetched[i]=1;
      var im=new Image(); im.decoding='async'; im.src=t.bg;
    }

    function select(i){
      var t=cfg.tabs[i]; if(!t) return;
      tabs.forEach(function(b,j){ b.setAttribute('aria-selected', j===i?'true':'false'); });
      if(bgEl && !staticBg){
        if(t.bg){
          bgEl.style.backgroundImage='linear-gradient(90deg, rgba(0,0,0,.82) 0%, rgba(0,0,0,.5) 36%, rgba(0,0,0,.12) 68%, rgba(0,0,0,.3) 100%), url("'+t.bg+'")';
        } else {
          bgEl.style.backgroundImage='';
        }
      }
      root.querySelector('.hp-num').textContent=t.num||'';
      root.querySelector('.hp-title').textContent=t.title||'';
      root.querySelector('.hp-desc').textContent=t.desc||'';
      var card=root.querySelector('.hp-imgcard');
      card.style.backgroundImage = t.img ? 'url("'+t.img+'")' : 'none';
      var icon=root.querySelector('.hp-icon');
      if(t.icon){ icon.src=t.icon; icon.style.display='block'; } else { icon.style.display='none'; }
      root.querySelectorAll('.hp-bullets').forEach(function(el){ el.innerHTML=t.bullets||''; });
      var r=parseInt(t.reveal,10); if(isNaN(r)||r<1) r=cfg.curve.length;
      buildChart(svg, cfg.curve, r);
    }

    tabs.forEach(function(b,i){
      b.addEventListener('click', function(){ select(i); });
      b.addEventListener('pointerenter', function(){ prefetch(i); });
      b.addEventListener('focus', function(){ prefetch(i); });
    });

    prefetched[0]=1; /* first bg already preloaded in markup */
    select(0);
    root.dataset.hpInit="1";
  }

  function initAll(scope){
    (scope||document).querySelectorAll('[data-hp-section]').forEach(initSection);
  }

  if(document.readyState!=='loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e){
    var el=e.target.querySelector('[data-hp-section]');
    if(el){ el.dataset.hpInit=''; initSection(el); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
